import { getOr } from '@/utils/options';
import * as React from 'react';
import ReactPlayer from 'react-player/youtube';
import { Maybe } from 'types/generated';
import { motion } from 'framer-motion';

type Props = {
  videoId?: Maybe<string>;
  autoPlay?: Maybe<boolean>;
  muted?: Maybe<boolean>;
  loop?: Maybe<boolean>;
};

const VideoPlayer = ({ videoId, autoPlay, muted, loop }: Props) => {
  const [hasRendered, setHasRendered] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    setHasRendered(true);
  }, []);

  return (
    <div className="relative h-full w-full">
      {isLoading && (
        <motion.div
          className="absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-black-25"
          initial={{ opacity: 0.1 }}
          animate={{ opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 3, repeat: Infinity }}
        ></motion.div>
      )}
      {videoId && hasRendered && (
        <ReactPlayer
          url={`https://www.youtube.com/watch?v=${videoId}`}
          height={'100%'}
          width={'100%'}
          muted={getOr(muted, false)}
          playing={getOr(autoPlay, false)}
          controls
          loop={getOr(loop, false)}
          onReady={() => setIsLoading(false)}
        />
      )}
    </div>
  );
};
export default VideoPlayer;
